'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import { isProminentLoaded, getProminent } from 'redux/modules/shops';

// import { asyncConnect } from 'redux-async-connect';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _filter = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _lib = require('../../../helpers/lib');

var _ic_check = require('../../../../static/icon/ic_check/ic_check.png');

var _ic_check2 = _interopRequireDefault(_ic_check);

var _ic_uncheck = require('../../../../static/icon/ic_uncheck/ic_uncheck.png');

var _ic_uncheck2 = _interopRequireDefault(_ic_uncheck);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterNewShop = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    categories: state.setup.categories
  };
}, (0, _extends3.default)({}, shopActions, filterActions, addressActions, setupActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FilterNewShop, _Component);

  function FilterNewShop() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FilterNewShop);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FilterNewShop.__proto__ || (0, _getPrototypeOf2.default)(FilterNewShop)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      categories: _this.props.categories || [],
      tempCat: '',
      catsActive: [],
      subList: [],
      subsActive: _this.props.subsActive || {},
      showSubFilter: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FilterNewShop, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // this.setState();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Những trường hợp thằng cha thay đổi.
      // TODO 1: Thay đổi category.
      if (nextProps.catsActive !== this.state.catsActive) {
        this.setState({ catsActive: nextProps.catsActive });
      }
      if (!(0, _lodash.isEqual)(nextProps.subsActive, this.state.subsActive)) {
        this.setState({ subsActive: nextProps.subsActive });
      }
    }
  }, {
    key: 'handleCategory',
    value: function handleCategory(cat) {
      // TODO: click vào cat đã chọn, click vào cat chưa chọn.
      var code = String(cat.code);
      var tempCat = code;
      var subList = cat.childrens;
      var catsActive = [].concat((0, _toConsumableArray3.default)(this.state.catsActive));
      var subsActive = (0, _extends3.default)({}, this.state.subsActive);
      var i = catsActive.indexOf(code);
      if (i !== -1) {
        // Đã có trước đó, bỏ chọn cat.
        // 1. Xóa subsActive của cat đó.
        // 2. Bỏ trong mảng catsActive.
        subsActive[code] = [];
        tempCat = '';
        catsActive = catsActive.filter(function (v) {
          return v !== code;
        });
      } else {
        catsActive.push(code);
        this.toggleSubFilter();
      }
      this.setState({ catsActive: catsActive, subList: subList, subsActive: subsActive, tempCat: tempCat });
    }
  }, {
    key: 'handleSubCategory',
    value: function handleSubCategory(code) {
      var _state = this.state,
          subsActive = _state.subsActive,
          tempCat = _state.tempCat;
      // Trường hợp này bắt buộc tempCat phải có giá trị đúng, nếu không đúng thì xem luồng trước đó code sai.

      var _subsActive = (0, _extends3.default)({}, subsActive);
      var pSubs = [].concat((0, _toConsumableArray3.default)(subsActive[tempCat]));
      var i = pSubs.indexOf(code);
      if (i !== -1) {
        pSubs = pSubs.filter(function (v) {
          return v !== code;
        });
      } else {
        pSubs.push(code);
      }
      _subsActive[tempCat] = pSubs;
      this.setState({ subsActive: _subsActive });
    }
  }, {
    key: 'classCat',
    value: function classCat(code) {
      var styles = require('./FilterNewShop.scss');
      switch (code) {
        case '01':
          return styles.spa;
        case '02':
          return styles.hair;
        case '03':
          return styles.cosmetic;
        case '04':
          return styles.clinic;
        case '05':
          return styles.fitness;
        case '06':
          return styles.tatoo;
        default:
          break;
      }
    }
  }, {
    key: 'toggleSubFilter',
    value: function toggleSubFilter() {
      this.setState({ showSubFilter: !this.state.showSubFilter });
    }
  }, {
    key: 'renderCat',
    value: function renderCat() {
      var _this2 = this;

      var styles = require('./FilterNewShop.scss');
      var _state2 = this.state,
          cats = _state2.categories,
          catsActive = _state2.catsActive,
          subsActive = _state2.subsActive;

      if (cats && cats.length > 0) {
        return _react2.default.createElement(
          'div',
          { className: styles.pWrapper },
          cats.map(function (cat, i) {
            var childrens = cat.childrens;
            var subs = [];
            if (subsActive && subsActive[cat.code] && childrens.length > 0) {
              childrens.map(function (v) {
                if (subsActive[cat.code].indexOf(String(v.code)) !== -1) {
                  subs.push(v.label);
                }
              });
            }
            return _react2.default.createElement(
              'div',
              {
                className: styles.pItem + ' ' + (catsActive.indexOf(cat.code) !== -1 ? styles.active : '')
              },
              _react2.default.createElement(
                'a',
                {
                  key: 'cat_' + i,
                  className: styles.item + ' ' + _this2.classCat(cat.code),
                  onClick: function onClick() {
                    return _this2.handleCategory(cat);
                  }
                },
                _react2.default.createElement(
                  'div',
                  { className: styles.info },
                  _react2.default.createElement(
                    'div',
                    { className: styles.image },
                    (0, _lib.iconCat)(cat.code, catsActive)
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.name },
                    _react2.default.createElement(
                      'span',
                      null,
                      cat.label
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: styles.subName },
                      catsActive.indexOf(cat.code) !== -1 ? subs.join(', ') : ''
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.isCheck },
                  catsActive.indexOf(cat.code) !== -1 ? _react2.default.createElement('img', { src: _ic_check2.default }) : _react2.default.createElement('img', { src: _ic_uncheck2.default })
                )
              )
            );
          })
        );
      }
    }
  }, {
    key: 'renderSubList',
    value: function renderSubList() {
      var _this3 = this;

      var styles = require('./FilterNewShop.scss');
      var _state3 = this.state,
          subList = _state3.subList,
          subsActive = _state3.subsActive,
          tempCat = _state3.tempCat;

      var _subsActive = [];
      if (subsActive && tempCat && subsActive[tempCat] && subsActive[tempCat].length > 0) {
        _subsActive = subsActive[tempCat];
      }
      return _react2.default.createElement(
        'div',
        { className: styles.pWrapper },
        subList.length && subList.map(function (sub, i) {
          return _react2.default.createElement(
            'div',
            {
              className: styles.pItem + ' ' + styles.sublist + (_subsActive.indexOf(String(sub.code)) !== -1 ? ' ' + styles.active : ''),
              key: 'sublist_' + i,
              onClick: function onClick() {
                return _this3.handleSubCategory(sub.code);
              }
            },
            _react2.default.createElement(
              'span',
              null,
              sub.label
            ),
            _subsActive.indexOf(String(sub.code)) !== -1 ? _react2.default.createElement('img', { src: _ic_check2.default }) : _react2.default.createElement('img', { src: _ic_uncheck2.default })
          );
        })
      );
    }
  }, {
    key: 'handleCloseFilter',
    value: function handleCloseFilter() {
      var toggleFilter = this.props.toggleFilter;
      // Tất cả những gì trong filter là tạm.
      // Do vậy khi không submit, ngoài việc thoát khỏi filter, còn phải RESET LẠI FILTER MẶC ĐỊNH.
      // this.resetFilter();

      toggleFilter();
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var handleSubmit = this.props.handleSubmit;
      var _state4 = this.state,
          catsActive = _state4.catsActive,
          subsActive = _state4.subsActive;

      var allCats = [].concat((0, _toConsumableArray3.default)(catsActive));
      catsActive.map(function (code) {
        allCats = [].concat((0, _toConsumableArray3.default)(allCats), (0, _toConsumableArray3.default)(subsActive[code]));
      });
      var filter = { catsActive: catsActive, subsActive: subsActive, allCats: allCats };
      handleSubmit(filter);
    }
  }, {
    key: 'render',
    value: function render() {
      // TODO: Cái filter cần List types, sublist và area.
      var styles = require('./FilterNewShop.scss');
      var showFilter = this.props.showFilter;
      // let subsActive = [];
      // if (currentFilterActive) {
      //   subsActive = subCatFilter[currentFilterActive];
      // }

      var showSubFilter = this.state.showSubFilter;
      // const types = [];

      return _react2.default.createElement(
        'div',
        { className: styles.pfilter },
        _react2.default.createElement('div', {
          className: styles.bgcover + ' ' + (showFilter ? styles.show : '')
        }),
        _react2.default.createElement(
          'div',
          {
            className: styles.filterDropdown + ' ' + (showFilter ? styles.show : '')
          },
          _react2.default.createElement('div', { className: styles.mysteryborder }),
          _react2.default.createElement(
            'div',
            { className: styles.filterHeader },
            _react2.default.createElement('div', {
              className: styles.close,
              onClick: this.handleCloseFilter.bind(this)
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.filterContent },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              'B\u1ED9 l\u1ECDc'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.typeBox },
              _react2.default.createElement(
                'div',
                { className: styles.titleTypes },
                _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'tasks' }),
                'Danh m\u1EE5c'
              ),
              this.renderCat()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.filterFooter },
            _react2.default.createElement(
              'div',
              { className: styles.btnSubmit, onClick: this.handleSubmit.bind(this) },
              '\xC1p D\u1EE5ng'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: styles.filterDropdown + ' ' + styles.subFilter + ' ' + (showSubFilter ? styles.show : '')
          },
          _react2.default.createElement(
            'div',
            { className: styles.filterHeader },
            _react2.default.createElement('img', {
              src: 'icon/ic_back/ic_back.png',
              onClick: this.toggleSubFilter.bind(this)
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.filterContent },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              'B\u1ED9 l\u1ECDc'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.subBox },
              this.renderSubList()
            )
          )
        )
      );
    }
  }]);
  return FilterNewShop;
}(_react.Component), _class2.propTypes = {
  categories: _react.PropTypes.array,
  subsActive: _react.PropTypes.object,
  catsActive: _react.PropTypes.array,
  toggleFilter: _react.PropTypes.func,
  handleSubmit: _react.PropTypes.func,
  showFilter: _react.PropTypes.bool
}, _temp2)) || _class);
exports.default = FilterNewShop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/NewShopMobile/FilterNewShop.js
// module id = 1614
// module chunks = 0